import { render, staticRenderFns } from "./DataPage.vue?vue&type=template&id=24a88c69&scoped=true&"
import script from "./DataPage.vue?vue&type=script&lang=js&"
export * from "./DataPage.vue?vue&type=script&lang=js&"
import style0 from "./DataPage.vue?vue&type=style&index=0&id=24a88c69&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a88c69",
  null
  
)

export default component.exports